module.exports = __webpack_public_path__ + "img/preliving.64467ea1.jpg";